import { render, staticRenderFns } from "./orderFormView.vue?vue&type=template&id=f44bea80&scoped=true&"
import script from "./orderFormView.vue?vue&type=script&lang=js&"
export * from "./orderFormView.vue?vue&type=script&lang=js&"
import style0 from "./orderFormView.vue?vue&type=style&index=0&id=f44bea80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44bea80",
  null
  
)

export default component.exports